import { html, SYSFormElement } from "../../../../../../_ovlclient/src"

export class CompBPFilter extends SYSFormElement {
  async init() {
    await super.init()
  }
  async getUI() {
    let cardCodeField = this.formState.fields["CardCode"]
    return html`
      <ovl-listcontrol .props=${() => cardCodeField}></ovl-listcontrol>
    `
  }
}
